document.addEventListener('DOMContentLoaded',function(){
(function () {
  'use strict';

  /* ============================================================
     AUDIO
  ============================================================ */
  var AU = {
    bgm:      'https://cdn.shopify.com/s/files/1/0642/4385/9567/files/aim-trainer-music.ogg?v=1772306947',
    error:    'https://cdn.shopify.com/s/files/1/0642/4385/9567/files/aim-trainer-shot-miss.ogg?v=1772306946',
    select:   'https://cdn.shopify.com/s/files/1/0642/4385/9567/files/aim-trainer-shot-clear.ogg?v=1772306946',
    linear:   'https://cdn.shopify.com/s/files/1/0642/4385/9567/files/Linear.ogg?v=1773085058',
    tactile:  'https://cdn.shopify.com/s/files/1/0642/4385/9567/files/Tactile.ogg?v=1773085058',
    clicky:   'https://cdn.shopify.com/s/files/1/0642/4385/9567/files/Clicky.ogg?v=1773085058',
    magnetic: 'https://cdn.shopify.com/s/files/1/0642/4385/9567/files/magnetic.ogg?v=1773093991',
    hit15:    'https://cdn.shopify.com/s/files/1/0642/4385/9567/files/aim-trainer-5hit.ogg?v=1772306946',
    hit30:    'https://cdn.shopify.com/s/files/1/0642/4385/9567/files/aim-trainer-10_streak.ogg?v=1773087209',
    complete: 'https://cdn.shopify.com/s/files/1/0642/4385/9567/files/aim-trainer-complete.ogg?v=1773090591'
  };

  var SWITCH_SFX = { linear:'linear', clicky:'clicky', tactile:'tactile', magnetic:'magnetic' };

  var audioCtx   = null;
  var buffers    = {};
  var bgmSource  = null;
  var bgmGain    = null;
  var masterGain = null;
  var muted      = false;
  var loadQueue  = Object.keys(AU).length;

  try { if (localStorage.getItem('kg_audio_muted') === '1') { muted = true; } } catch (e) {}

  function initAudio() {
    if (audioCtx) return;
    try {
      audioCtx   = new (window.AudioContext || window.webkitAudioContext)();
      masterGain = audioCtx.createGain();
      masterGain.gain.value = muted ? 0 : 1;
      masterGain.connect(audioCtx.destination);
      bgmGain = audioCtx.createGain();
      bgmGain.gain.value = 0.18;
      bgmGain.connect(masterGain);
      Object.keys(AU).forEach(function (key) {
        fetch(AU[key])
          .then(function (r) { return r.arrayBuffer(); })
          .then(function (ab) { return audioCtx.decodeAudioData(ab); })
          .then(function (buf) { buffers[key] = buf; loadQueue--; })
          .catch(function () { loadQueue--; });
      });
    } catch (e) {}
  }

  function startBgm() {
    if (!audioCtx || !buffers.bgm || bgmSource) return;
    bgmSource = audioCtx.createBufferSource();
    bgmSource.buffer = buffers.bgm;
    bgmSource.loop   = true;
    bgmSource.connect(bgmGain);
    bgmSource.start(0);
  }

  function playOnce(key, vol, pitch) {
    if (!audioCtx || !buffers[key] || muted) return;
    if (audioCtx.state === 'suspended') { audioCtx.resume(); }
    var src = audioCtx.createBufferSource();
    src.buffer = buffers[key];
    if (pitch) { src.playbackRate.value = pitch; }
    var g = audioCtx.createGain();
    g.gain.value = (vol !== undefined) ? vol : 1.0;
    src.connect(g); g.connect(masterGain); src.start(0);
  }

  function playPreview(sw) {
    var sfxKey = SWITCH_SFX[sw] || 'linear';
    playOnce(sfxKey, 0.55, 0.97 + Math.random() * 0.06);
    
  }

  function playKeySfx(correct) {
    if (!audioCtx || muted) return;
    if (!correct) { playOnce('error', 0.70); return; }
    var sfxKey = SWITCH_SFX[state.selectedSwitch] || 'linear';
    playOnce(sfxKey, 0.85, 0.94 + Math.random() * 0.12);
  }

  var muteBtn = document.getElementById('kgMuteBtn');
  function applyMute() {
    if (masterGain) { masterGain.gain.value = muted ? 0 : 1; }
    muteBtn.classList.toggle('muted', muted);
    muteBtn.innerHTML = muted ? '&#128263;' : '&#128266;';
    try { localStorage.setItem('kg_audio_muted', muted ? '1' : '0'); } catch (e) {}
  }
  muteBtn.addEventListener('click', function () { muted = !muted; applyMute(); });
  if (muted) { muteBtn.classList.add('muted'); muteBtn.innerHTML = '&#128263;'; }

  /* ============================================================
     WIN QUIPS
  ============================================================ */
  var WIN_QUIPS = [
    'Congratulations. You defeated several pixels.',
    'We honestly didn\'t think you\'d get this far.',
    'Achievement Unlocked: Too Much Free Time.',
    'Your prize is this text. We hope you\'re happy.',
    'The developers fear you now.',
    'Your next upgrade: an actual mechanical keyboard.',
    'You broke the game. Please stop.',
    'Somewhere, a potato is proud of you.',
    'The simulation has noted your performance.',
    'You win! The universe remains mostly intact.',
    'This message took longer to write than the game took to beat.',
    'The cake is a lie. So is this trophy.',
    'Test terminated. Typist threat level: critical.',
    'You typed words at a screen and won. Reflect on that.',
    'Good. Now do it again but faster.',
    'Your keyboard will remember this. It\'s scared.',
    'Congratulations. This changes nothing.',
    'You have been added to a list. We won\'t say which one.',
    'Error 404: Worthy opponent not found.',
    'Now find the switch that got you here.'
  ];
  var lastQuipIndex = -1;
  function pickQuip() {
    var idx;
    do { idx = Math.floor(Math.random() * WIN_QUIPS.length); } while (idx === lastQuipIndex);
    lastQuipIndex = idx;
    return WIN_QUIPS[idx];
  }

  /* ============================================================
     SWITCH LABELS
  ============================================================ */
  var SWITCH_LABELS = {
    linear:   'Linear (Red)',
    clicky:   'Clicky (Blue)',
    tactile:  'Tactile (Brown)',
    magnetic: 'Magnetic (Hall Effect)'
  };

  /* ============================================================
     SWITCH SELECT
  ============================================================ */
  var switchCards  = document.querySelectorAll('.kg-switch-card');
  var switchHint   = document.getElementById('kgSwitchHint');
  var startBtn     = document.getElementById('kgStartBtn');

  switchCards.forEach(function (card) {
    var sw = card.getAttribute('data-switch');
    card.addEventListener('mouseenter', function () {
      if (!audioCtx) { initAudio(); return; }
      if (audioCtx.state === 'suspended') { audioCtx.resume(); }
      if (buffers[SWITCH_SFX[sw]]) { playPreview(sw); }
    });
    card.addEventListener('focus', function () { if (!audioCtx) initAudio(); });
    card.addEventListener('click', function () {
      if (!audioCtx) initAudio();
      if (audioCtx && audioCtx.state === 'suspended') { audioCtx.resume(); }
      switchCards.forEach(function (c) { c.classList.remove('selected'); });
      card.classList.add('selected');
      state.selectedSwitch = sw;
      playOnce('select', 0.70);
      switchHint.textContent = SWITCH_LABELS[sw] + ' selected -- ready to go';
      switchHint.classList.add('active');
      /* Unlock start button */
      startBtn.disabled      = false;
      startBtn.style.opacity = '1';
      startBtn.style.cursor  = 'pointer';
      document.getElementById('kgStartChipLabel').textContent = 'Switch: ' + SWITCH_LABELS[sw];
      document.getElementById('kgStartHint').textContent = 'Click or press any key to begin';
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
    });
  });

  /* ============================================================
     WORD BANK
  ============================================================ */
  var WORDS = [
    'the','and','for','are','but','not','you','all','can','had','her','was','one','our','out',
    'day','get','has','him','his','how','man','new','now','old','see','two','way','who','boy',
    'did','its','let','put','say','she','too','use','just','know','take','into','year','your',
    'good','much','some','time','very','when','come','here','make','most','than','them',
    'then','they','this','will','with','have','from','that','what','been','call','down','each',
    'find','give','hand','help','high','home','keep','kind','land','last','left','life','long',
    'look','made','many','mean','move','must','name','need','next','open','over','part','play',
    'real','same','seem','show','side','soon','such','sure','tell','turn','upon','used','want',
    'well','went','were','wide','wish','word','work','also','back','body','book','both','case',
    'city','cost','does','door','draw','even','ever','face','fact','feel','feet','form','four',
    'free','full','gave','goes','gone','grow','half','hard','head','hear','held','hold','idea',
    'knew','lake','late','lead','lean','line','list','live','load','lose','loud','love',
    'meet','mind','miss','more','near','note','once','only','past','path','plan','pool','push',
    'read','rest','rich','ride','ring','road','rock','role','room','rule','rush','safe','sail',
    'salt','sand','save','self','send','sent','ship','shot','sign','sing','site','size','skin',
    'slow','soft','soil','sold','song','sort','soul','step','stop','suit','swim','talk','tall',
    'task','team','test','text','tied','till','tiny','told','tone','tool','town','tree','trip',
    'true','tune','type','unit','view','vote'
  ];

  /* ============================================================
     MODE CONFIG + VICTORY THRESHOLDS
  ============================================================ */
  var MODES = {
    speed: { duration:15, label:'Speed Burst', color:'#4a7fff', timerColor:'#4a7fff' },
    prec:  { duration:30, label:'Precision',   color:'#66ff99', timerColor:'#66ff99' },
    mara:  { duration:60, label:'Marathon',    color:'#ffca28', timerColor:'#ffca28' },
    free:  { duration:0,  label:'Free Play',   color:'#c084fc', timerColor:'#c084fc' }
  };
  var WIN_THRESHOLDS = { speed:70, prec:95, mara:80 };

  /* ============================================================
     RECOMMENDATIONS
  ============================================================ */
  function getRecommendation(mode, wpm, acc, consist) {
    if (mode === 'speed') {
      if (acc >= 97) return { name:'Tactile Linear', tag:'tactile', icon:'&#9670;', color:'#66ff99', bg:'rgba(102,255,153,.12)', desc:'High speed AND high accuracy means disciplined finger control. A light tactile gives you the feedback bump without slowing you down.' };
      return { name:'Linear Switch', tag:'linear', icon:'&#9889;', color:'#4a7fff', bg:'rgba(74,127,255,.12)', desc:'Fast typists who trade accuracy for speed benefit most from a smooth linear. No bump to interrupt rapid keypresses -- just pure travel.' };
    }
    if (mode === 'prec') {
      if (acc >= 98) return { name:'Clicky Switch', tag:'clicky', icon:'&#9632;', color:'#ffca28', bg:'rgba(255,202,40,.12)', desc:'Near-perfect accuracy with a deliberate pace -- the audible click confirms every keystroke. Zero ghosting, maximum confidence.' };
      return { name:'Tactile Switch', tag:'tactile', icon:'&#9670;', color:'#66ff99', bg:'rgba(102,255,153,.12)', desc:'Precision typists benefit from the tactile bump as physical confirmation the key registered. Quieter than clicky but just as accurate.' };
    }
    if (consist >= 85) return { name:'Medium Tactile', tag:'tactile', icon:'&#9670;', color:'#66ff99', bg:'rgba(102,255,153,.12)', desc:'Consistent speed over 60 seconds means relaxed hands. A medium-weight tactile keeps fatigue low while still giving feedback on long sessions.' };
    if (consist >= 65) return { name:'Linear Switch',  tag:'linear',  icon:'&#9889;', color:'#4a7fff', bg:'rgba(74,127,255,.12)', desc:'Your speed dipped over time -- a lighter linear reduces actuation effort, helping maintain pace through longer sessions without strain.' };
    return { name:'Heavy Tactile', tag:'hall-effect', icon:'&#9632;', color:'#ffca28', bg:'rgba(255,202,40,.12)', desc:'Significant speed drop suggests bottoming out hard. A heavier spring and tactile feedback will train you to actuate earlier and reduce impact.' };
  }

  /* ============================================================
     STATE
  ============================================================ */
  var state = {
    mode:           'speed',
    phase:          'idle',
    selectedSwitch: null,
    words:          [],
    charIndex:      0,
    correct:        0,
    errors:         0,
    hits:           0,
    timerLeft:      15,
    timerTotal:     15,
    startTs:        0,
    lastKeyTs:      0,
    reactions:      [],
    wpmHistory:     [],
    wpmTimer:       null,
    countdown:      null,
    score:          0,
    correctStreak:  0,
    typed:          {}
  };

  /* DOM */
  var overlay    = document.getElementById('kgStartOverlay');
  var wordEl     = document.getElementById('kgWordDisplay');
  var inputTrap  = document.getElementById('kgInputTrap');
  var timerArc   = document.getElementById('kgTimerArc');
  var timerNum   = document.getElementById('kgTimerNum');
  var hudWpm     = document.getElementById('kgHudWpm');
  var hudAcc     = document.getElementById('kgHudAcc');
  var hudConsist = document.getElementById('kgHudConsist');
  var hudHits    = document.getElementById('kgHudHits');
  var resultsEl  = document.getElementById('kgResults');
  var reactCv    = document.getElementById('kgReactCanvas');
  var reactCtx   = reactCv.getContext('2d');
  var charList   = [];

  /* ============================================================
     WORD GENERATION
  ============================================================ */
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length-1; i > 0; i--) { var j = Math.floor(Math.random()*(i+1)); var t=a[i];a[i]=a[j];a[j]=t; }
    return a;
  }
  function generateWords(n) {
    var pool = shuffle(WORDS), out = [];
    while (out.length < n) { out = out.concat(pool.slice(0, n-out.length)); }
    return out.slice(0, n);
  }
  function buildCharList(words) {
    var list = [];
    for (var wi = 0; wi < words.length; wi++) {
      var w = words[wi] + (wi < words.length-1 ? ' ' : '');
      for (var ci = 0; ci < w.length; ci++) { list.push({ char:w[ci] }); }
    }
    return list;
  }

  /* ============================================================
     RENDER WORDS
  ============================================================ */
  function renderInitialWords() {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < charList.length; i++) {
      var span = document.createElement('span');
      span.className = 'kp';
      span.textContent = charList[i].char === ' ' ? ' ' : charList[i].char;
      frag.appendChild(span);
    }
    wordEl.innerHTML = '';
    wordEl.appendChild(frag);
  }

  function appendCharsToDOM(chars) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < chars.length; i++) {
      var span = document.createElement('span');
      span.className = 'kp';
      span.textContent = chars[i].char === ' ' ? ' ' : chars[i].char;
      frag.appendChild(span);
    }
    wordEl.appendChild(frag);
  }

  function updateChar(index, correct) {
    var span = wordEl.children[index];
    if (!span) return;
    span.className = correct ? 'kc' : 'kw';
  }

  function updateCursor(prevIndex, newIndex) {
    var prev = wordEl.children[prevIndex];
    if (prev && (prev.className === 'kcu')) { prev.className = 'kp'; }
    var next = wordEl.children[newIndex];
    if (next) { next.className = 'kcu'; }
  }

  var lineH = 0;

  function measureLineHeight() {
    var first = wordEl.children[0];
    if (!first) return;
    var second = null;
    var firstTop = first.offsetTop;
    for (var i = 1; i < wordEl.children.length; i++) {
      if (wordEl.children[i].offsetTop > firstTop) { second = wordEl.children[i]; break; }
    }
    lineH = second ? (second.offsetTop - firstTop) : (first.offsetHeight || 44);
    wordEl.style.setProperty('--kg-line-h', lineH + 'px');
    document.documentElement.style.setProperty('--kg-line-h', lineH + 'px');
  }

  function scrollToCursor() {
    var cursor = wordEl.children[state.charIndex];
    if (!cursor) return;
    if (lineH <= 0) return;
    var cursorLine = Math.floor((cursor.offsetTop - wordEl.offsetTop) / lineH);
    var currentTopLine = Math.round(wordEl.scrollTop / lineH);
    if (cursorLine >= currentTopLine + 2) {
      wordEl.scrollTop = (currentTopLine + 1) * lineH;
    }
  }

  /* ============================================================
     REACTION CHART
  ============================================================ */
  function drawReactChart() {
    var w = reactCv.offsetWidth || 600;
    reactCv.width = w;
    var h = 60, rs = state.reactions;
    reactCtx.clearRect(0, 0, w, h);
    if (!rs.length) return;
    var maxR = 0; for (var i=0;i<rs.length;i++){if(rs[i]>maxR)maxR=rs[i];}
    if (!maxR) return;
    var barW = Math.max(2, Math.min(8, Math.floor(w/rs.length)-1));
    var mc   = MODES[state.mode].color;
    var sum  = 0; for (var s=0;s<rs.length;s++){sum+=rs[s];}
    var avg  = sum/rs.length;
    var avgY = Math.round(h-(avg/maxR)*(h-6))+0.5;
    reactCtx.strokeStyle='rgba(255,255,255,.15)';reactCtx.setLineDash([3,3]);reactCtx.lineWidth=1;
    reactCtx.beginPath();reactCtx.moveTo(0,avgY);reactCtx.lineTo(w,avgY);reactCtx.stroke();reactCtx.setLineDash([]);
    for (var b=0;b<rs.length;b++) {
      var bh=Math.max(2,Math.round((rs[b]/maxR)*(h-6)));
      var bx=Math.round(b*(w/rs.length));
      var slow=rs[b]>avg*1.5;
      reactCtx.fillStyle=slow?'rgba(255,92,92,.70)':mc+'b3';
      reactCtx.fillRect(bx,h-bh,barW,bh);
    }
  }

  /* ============================================================
     LIVE STATS + VICTORY CHECK
  ============================================================ */
  function calcLiveStats() {
    var el  = (Date.now()-state.startTs)/60000;
    var wpm = el > 0 ? Math.round((state.correct/5)/el) : 0;
    var tot = state.correct+state.errors;
    var acc = tot > 0 ? Math.round((state.correct/tot)*100) : 100;
    var consist = 0;
    hudWpm.textContent  = wpm;
    hudAcc.textContent  = acc + '%';
    hudHits.textContent = state.hits;
    if (state.wpmHistory.length >= 3) {
      var rec=state.wpmHistory.slice(-10), mean=0;
      for(var i=0;i<rec.length;i++){mean+=rec[i];}mean/=rec.length;
      var vr=0;for(var j=0;j<rec.length;j++){vr+=Math.pow(rec[j]-mean,2);}
      var sd=Math.sqrt(vr/rec.length),cv=mean>0?sd/mean:1;
      consist=Math.max(0,Math.round((1-cv)*100));
      hudConsist.textContent=consist+'%';
    }
    /* Speed Burst: instant win when WPM threshold hit */
    if (state.mode === 'speed' && wpm >= WIN_THRESHOLDS.speed) {
      endTest(true);
    }
  }

  /* ============================================================
     TIMER ARC
  ============================================================ */
  var CIRC = 175.93;
  function updateTimerArc() {
    var pct=state.timerLeft/state.timerTotal;
    timerArc.style.strokeDashoffset=CIRC*(1-pct);
    timerNum.textContent=Math.ceil(state.timerLeft);
    if(pct<0.25){timerArc.style.stroke='#ff5c5c';}
    else if(pct<0.5){timerArc.style.stroke='#ffca28';}
    else{timerArc.style.stroke=MODES[state.mode].timerColor;}
  }

  /* ============================================================
     COUNTDOWN
  ============================================================ */
  function runCountdown(onComplete) {
    if (state.phase === 'running' || state.phase === 'countdown') return;
    if (!state.selectedSwitch) return;
    var done = onComplete || startTest;
    initAudio();
    state.phase = 'countdown';

    overlay.classList.remove('hidden');
    overlay.classList.remove('kg-win-overlay');

    var steps     = ['3','2','1','GO'];
    var durations = [900, 900, 900, 700];
    var pitches   = [0.85, 0.95, 1.05, 1.25];
    var idx = 0;

    function tick() {
      var label = steps[idx];
      var isGo  = label === 'GO';
      overlay.innerHTML =
        '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;">' +
        '<span class="kg-countdown-num' + (isGo ? ' go' : '') + '">' + label + '</span>' +
        '<div class="kg-countdown-label">' + (isGo ? 'type!' : 'get ready') + '</div>' +
        '</div>';
      var numEl = overlay.querySelector('.kg-countdown-num');
      playOnce('select', 0.55, pitches[idx]);
      var hold = durations[idx] - 260;
      idx++;
      setTimeout(function() {
        if (numEl) numEl.classList.add('fadeout');
        setTimeout(function() {
          if (idx < steps.length) { tick(); } else { done(); }
        }, 260);
      }, hold);
    }

    function go() {
      if (audioCtx && audioCtx.state === 'suspended') {
        audioCtx.resume().then(tick).catch(tick);
      } else {
        tick();
      }
    }
    go();
  }

  /* ============================================================
     START TEST
  ============================================================ */
  function startTest() {
    if (state.phase === 'running' || !state.selectedSwitch) return;
    initAudio();
    if (audioCtx && audioCtx.state === 'suspended') { audioCtx.resume(); }
    startBgm();
    var m = MODES[state.mode];
    state.phase          = 'running';
    state.words          = generateWords(200);
    state.charIndex      = 0;
    state.correct        = 0;
    state.errors         = 0;
    state.hits           = 0;
    state.timerLeft      = m.duration;
    state.timerTotal     = m.duration;
    state.startTs        = Date.now();
    state.lastKeyTs      = Date.now();
    state.reactions      = [];
    state.wpmHistory     = [];
    state.typed          = {};
    state.correctStreak  = 0;
    charList = buildCharList(state.words);
    wordEl.scrollTop = 0;
    overlay.classList.add('hidden');
    overlay.classList.remove('kg-win-overlay');
    resultsEl.classList.remove('visible');
    hudWpm.textContent='0';hudAcc.textContent='100%';hudConsist.textContent='--';hudHits.textContent='0';
    timerArc.style.strokeDashoffset=0;timerNum.textContent=m.duration;timerArc.style.stroke=m.timerColor;
    renderInitialWords();
    measureLineHeight();
    updateCursor(-1, 0);
    inputTrap.value='';inputTrap.focus();
    state.wpmTimer=setInterval(function(){
      if(state.phase!=='running')return;
      var el=(Date.now()-state.startTs)/60000;
      state.wpmHistory.push(el>0?Math.round((state.correct/5)/el):0);
    },2000);
    var tickStart=Date.now();
    state.countdown=setInterval(function(){
      state.timerLeft=m.duration-(Date.now()-tickStart)/1000;
      if(state.timerLeft<=0){state.timerLeft=0;endTest(false);}
      updateTimerArc();drawReactChart();calcLiveStats();
    },100);
  }

  /* ============================================================
     KEYPRESS
  ============================================================ */
  inputTrap.addEventListener('keydown', function (e) {
    if (state.phase !== 'running') return;
    if (e.key.length > 1 && e.key !== 'Backspace') return;
    var now=Date.now(),react=now-state.lastKeyTs;state.lastKeyTs=now;
    if (e.key === 'Backspace') {
      if (state.charIndex > 0) {
        updateCursor(state.charIndex, state.charIndex - 1);
        state.charIndex--;
        var bspan = wordEl.children[state.charIndex];
        if (bspan) { bspan.className = state.typed[state.charIndex] !== undefined ? (state.typed[state.charIndex] ? 'kc' : 'kw') : 'kp'; }
        delete state.typed[state.charIndex];
        var bcur = wordEl.children[state.charIndex];
        if (bcur) { bcur.className = 'kcu'; }
        scrollToCursor();
      }
      e.preventDefault(); return;
    }
    if (react < 2000) { state.reactions.push(react); }
    var expected=charList[state.charIndex]?charList[state.charIndex].char:null;
    if (!expected) return;
    state.hits++;
    var isCorrect=(e.key===expected);
    if (isCorrect) { state.correct++; state.typed[state.charIndex]=true; }
    else           { state.errors++;  state.typed[state.charIndex]=false; }
    playKeySfx(isCorrect);

    /* ── Streak logic: every 7 correct chars in a row → play hit sound ── */
    if (isCorrect) {
      state.correctStreak++;
      if (state.correctStreak % 7 === 0) {
        setTimeout(function(){ playOnce('hit15', 0.9); }, 30);
      }
    } else {
      state.correctStreak = 0;
    }

    updateChar(state.charIndex, isCorrect);
    state.charIndex++;
    updateCursor(state.charIndex - 1, state.charIndex);
    scrollToCursor();
    /* Refill: append more words when within 50 chars of the end */
    if (state.charIndex >= charList.length - 50) {
      var more = buildCharList(generateWords(80));
      charList = charList.concat(more);
      appendCharsToDOM(more);
    }
    /* Throttle chart draw: update every 4 keystrokes to save CPU */
    if (state.reactions.length % 4 === 0) { drawReactChart(); }
    e.preventDefault();
  });

  wordEl.addEventListener('click', function () { if(state.phase==='running'){inputTrap.focus();} });

  /* ============================================================
     FREE PLAY
  ============================================================ */
  function startFreePlay() {
    if (!state.selectedSwitch) return;
    state.phase          = 'running';
    state.words          = generateWords(200);
    state.charIndex      = 0;
    state.correct        = 0;
    state.errors         = 0;
    state.hits           = 0;
    state.timerLeft      = 0;
    state.timerTotal     = 0;
    state.startTs        = Date.now();
    state.lastKeyTs      = Date.now();
    state.reactions      = [];
    state.wpmHistory     = [];
    state.typed          = {};
    state.correctStreak  = 0;
    charList = buildCharList(state.words);
    wordEl.scrollTop = 0;
    overlay.classList.add('hidden');
    overlay.classList.remove('kg-win-overlay');
    resultsEl.classList.remove('visible');
    hudWpm.textContent='0';hudAcc.textContent='100%';hudConsist.textContent='--';hudHits.textContent='0';
    timerNum.textContent = '~';
    timerArc.style.stroke = '#c084fc';
    timerArc.style.strokeDashoffset = 175.93;
    var strip = document.getElementById('kgFpStrip');
    if (strip) {
      strip.style.display = 'flex';
      updateFpStrip();
    }
    renderInitialWords();
    measureLineHeight();
    updateCursor(-1, 0);
    inputTrap.value='';inputTrap.focus();
    state.wpmTimer = setInterval(function() {
      if (state.phase !== 'running') return;
      var el = (Date.now() - state.startTs) / 60000;
      state.wpmHistory.push(el > 0 ? Math.round((state.correct / 5) / el) : 0);
      calcLiveStats();
      drawReactChart();
    }, 2000);
  }

  function updateFpStrip() {
    var btns = document.querySelectorAll('.kg-fp-sw-btn');
    btns.forEach(function(b) {
      b.classList.toggle('active', b.getAttribute('data-switch') === state.selectedSwitch);
    });
  }

  function stopFreePlay() {
    clearInterval(state.wpmTimer);
    var strip = document.getElementById('kgFpStrip');
    if (strip) strip.style.display = 'none';
    resetToIdle();
  }

  /* ============================================================
     END TEST
  ============================================================ */
  function endTest(isWin) {
    if (state.phase !== 'running') return;
    clearInterval(state.countdown);clearInterval(state.wpmTimer);
    state.phase='done';
    var elapsed=(Date.now()-state.startTs)/60000;
    var wpm=elapsed>0?Math.round((state.correct/5)/elapsed):0;
    var tot=state.correct+state.errors;
    var acc=tot>0?Math.round((state.correct/tot)*100):100;
    var consist=0;
    if(state.wpmHistory.length>=2){
      var hist=state.wpmHistory,mn=0;
      for(var i=0;i<hist.length;i++){mn+=hist[i];}mn/=hist.length;
      var vr=0;for(var j=0;j<hist.length;j++){vr+=Math.pow(hist[j]-mn,2);}
      var sd=Math.sqrt(vr/hist.length),cv=mn>0?sd/mn:1;
      consist=Math.max(0,Math.round((1-cv)*100));
    }
    var avgReact=0;
    if(state.reactions.length){var rs=0;for(var r=0;r<state.reactions.length;r++){rs+=state.reactions[r];}avgReact=Math.round(rs/state.reactions.length);}
    if (!isWin) {
      if (state.mode==='prec' && acc>=WIN_THRESHOLDS.prec)       { isWin=true; }
      if (state.mode==='mara' && consist>=WIN_THRESHOLDS.mara)   { isWin=true; }
    }
    var modeBonus=state.mode==='prec'?2:state.mode==='mara'?1.5:1;
    state.score=Math.round(wpm*(acc/100)*modeBonus);
    state.finalWpm=wpm;state.finalAcc=acc;state.finalCon=consist;state.finalReact=avgReact;
    if(isWin){ setTimeout(function(){playOnce('complete',1.0);},60); }
    document.getElementById('kgResWpm').textContent=wpm;
    document.getElementById('kgResAcc').textContent=acc+'%';
    document.getElementById('kgResConsist').textContent=consist+'%';
    document.getElementById('kgResReact').textContent=avgReact+'ms';
    var rec=getRecommendation(state.mode,wpm,acc,consist);
    var icon=document.getElementById('kgRecIcon');
    icon.innerHTML=rec.icon;icon.style.background=rec.bg;
    icon.style.boxShadow='0 0 16px '+rec.color+'44';icon.style.color=rec.color;
    document.getElementById('kgRecName').textContent=rec.name;
    document.getElementById('kgRecName').style.color=rec.color;
    document.getElementById('kgRecDesc').textContent=rec.desc;
    try{sessionStorage.setItem('kg_switch_rec',rec.name);sessionStorage.setItem('kg_mode_color',rec.color);sessionStorage.setItem('kg_switch_tag',rec.tag||'');}catch(e){}
    try{var kgEvtDetail={rec:rec.name,clr:rec.color,tag:rec.tag||''};window.dispatchEvent(new CustomEvent('kg:rec:set',{detail:kgEvtDetail}));}catch(e){}
    resultsEl.classList.add('visible');
    drawReactChart();
    overlay.classList.remove('hidden');
    if(isWin){ showWinOverlay(wpm,acc,consist,avgReact); }
    else      { showRetryOverlay(wpm,acc,consist); }
  }

  /* ============================================================
     WIN OVERLAY
  ============================================================ */
  function showWinOverlay(wpm,acc,consist,react) {
    overlay.innerHTML='';
    overlay.classList.add('kg-win-overlay');
    var hl=document.createElement('div');hl.className='kg-win-headline';hl.textContent='VICTORY';
    var qp=document.createElement('div');qp.className='kg-win-quip';qp.textContent=pickQuip();
    var sr=document.createElement('div');sr.className='kg-win-stats-row';
    function mk(v,l){var d=document.createElement('div');d.className='kg-win-stat';d.innerHTML='<div class="kg-win-stat-val">'+v+'</div><div class="kg-win-stat-lbl">'+l+'</div>';return d;}
    sr.appendChild(mk(wpm+' WPM','Speed'));
    sr.appendChild(mk(acc+'%','Accuracy'));
    sr.appendChild(mk(consist+'%','Consistency'));
    sr.appendChild(mk(react+'ms','Avg React'));
    var rb=document.createElement('button');rb.className='kg-win-retry-btn';rb.textContent='Play Again';
    rb.addEventListener('click',resetToIdle);
    overlay.appendChild(hl);overlay.appendChild(qp);overlay.appendChild(sr);overlay.appendChild(rb);
  }

  /* ============================================================
     RETRY OVERLAY  — FIX 1: larger "Time's Up" text
  ============================================================ */
  function showRetryOverlay(wpm,acc,consist) {
    overlay.innerHTML='';
    overlay.classList.remove('kg-win-overlay');
    var goalMsg='';
    if(state.mode==='speed')     goalMsg='You hit '+wpm+' WPM \u2014 goal is 70';
    else if(state.mode==='prec') goalMsg='Finished at '+acc+'% \u2014 goal is 95%';
    else                         goalMsg='Consistency: '+consist+'% \u2014 goal is 80%';
    overlay.innerHTML=
      '<div style="font-family:var(--kg-fH);font-size:2.6rem;font-weight:700;letter-spacing:.10em;text-transform:uppercase;color:var(--kg-chrome);margin-bottom:.6rem;">Time\'s Up</div>'+
      '<div style="font-family:var(--kg-fM);font-size:1.05rem;letter-spacing:.06em;color:var(--kg-dim);margin-bottom:1.6rem;text-align:center;">'+goalMsg+'</div>'+
      '<button class="kg-start-btn" id="kgRetryOverlayBtn">Try Again</button>';
    document.getElementById('kgRetryOverlayBtn').addEventListener('click',resetToIdle);
  }

  /* ============================================================
     RESET TO IDLE
  ============================================================ */
  function resetToIdle() {
    state.phase='idle';
    resultsEl.classList.remove('visible');
    overlay.classList.remove('hidden','kg-win-overlay');
    var chipLabel=state.selectedSwitch?('Switch: '+SWITCH_LABELS[state.selectedSwitch]):'Select a switch above first';
    var hintText=state.selectedSwitch?'Click or press any key to begin':'Select a switch above to begin';
    overlay.innerHTML=
      '<div class="kg-start-switch-chip"><span class="kg-start-switch-dot"></span><span id="kgStartChipLabel">'+chipLabel+'</span></div>'+
      '<button class="kg-start-btn" id="kgStartBtn"'+(state.selectedSwitch?'':' disabled style="opacity:.45;cursor:not-allowed;"')+'>Start Test</button>'+
      '<div class="kg-start-hint" id="kgStartHint">'+hintText+'</div>';
    document.getElementById('kgStartBtn').addEventListener('click',function(){
      if (!state.selectedSwitch) return;
      if (state.mode === 'free') {
        runCountdown(startFreePlay);
      } else {
        runCountdown();
      }
    });
    var strip = document.getElementById('kgFpStrip');
    if (strip) strip.style.display = 'none';
    if (state.mode === 'free') {
      timerNum.textContent = '~';
      timerArc.style.stroke = MODES.free.color;
      timerArc.style.strokeDashoffset = 175.93;
    } else {
      timerNum.textContent = MODES[state.mode].duration;
      timerArc.style.stroke = MODES[state.mode].timerColor;
      timerArc.style.strokeDashoffset = 0;
    }
    hudWpm.textContent='0';hudAcc.textContent='100%';hudConsist.textContent='--';hudHits.textContent='0';
    wordEl.innerHTML='';wordEl.scrollTop=0;
    reactCtx.clearRect(0,0,reactCv.width,reactCv.height);
  }

  /* ============================================================
     MODE SWITCHING
  ============================================================ */
  document.querySelectorAll('.kg-mode-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(state.phase==='running'||state.phase==='countdown')return;
      state.mode=btn.getAttribute('data-mode');
      document.querySelectorAll('.kg-mode-btn').forEach(function(b){b.classList.remove('active-speed','active-prec','active-mara');b.setAttribute('aria-selected','false');});
      btn.classList.add('active-'+state.mode);btn.setAttribute('aria-selected','true');
      initAudio();
      playOnce('select', 0.45, 1.0);
      if (state.mode === 'free') {
        timerNum.textContent = '~';
        timerArc.style.stroke = MODES.free.color;
        timerArc.style.strokeDashoffset = 175.93;
      } else {
        timerNum.textContent = MODES[state.mode].duration;
        timerArc.style.stroke = MODES[state.mode].timerColor;
        timerArc.style.strokeDashoffset = 0;
      }
      var lbSection = document.querySelector('.kg-lb-section');
      if (lbSection) lbSection.style.display = 'none';
    });
  });

  /* ============================================================
     FREE PLAY STRIP WIRING
  ============================================================ */
  document.querySelectorAll('.kg-fp-sw-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var sw = btn.getAttribute('data-switch');
      state.selectedSwitch = sw;
      document.querySelectorAll('.kg-switch-card').forEach(function(c) {
        c.classList.toggle('selected', c.getAttribute('data-switch') === sw);
      });
      updateFpStrip();
      playOnce('select', 0.4, 1.0);
      try {
        var SWITCH_LABELS_FP = {linear:'Linear',clicky:'Clicky',tactile:'Tactile',magnetic:'Magnetic Hall Effect'};
        sessionStorage.setItem('kg_switch_rec',  SWITCH_LABELS_FP[sw] || sw);
        sessionStorage.setItem('kg_switch_tag',  sw === 'magnetic' ? 'hall-effect' : sw);
        sessionStorage.setItem('kg_mode_color',  MODES.free.color);
      } catch(e) {}
    });
  });

  var fpStopBtn = document.getElementById('kgFpStopBtn');
  if (fpStopBtn) {
    fpStopBtn.addEventListener('click', stopFreePlay);
  }

  /* ============================================================
     GLOBAL KEY TO START
  ============================================================ */
  document.addEventListener('keydown',function(e){
    if(state.phase==='idle'&&e.key.length===1&&state.selectedSwitch){
      if (state.mode === 'free') { runCountdown(startFreePlay); } else { runCountdown(); }
    }
  });
  document.getElementById('kgRetryBtn').addEventListener('click',resetToIdle);

  /* ============================================================
     INIT
  ============================================================ */
  var rzTimer;
  window.addEventListener('resize',function(){clearTimeout(rzTimer);rzTimer=setTimeout(function(){drawReactChart();},120);},{passive:true});

})();
}); // DOMContentLoaded